import { ChangeEvent, FC } from 'react';
import { useParams } from 'react-router-dom';
import { Switch, SwitchProps } from '@mui/material';
import { useAutoStopWorkbenchMutation, useDeleteAutoStopWorkbenchMutation } from '~/api/v2/hooks';

interface WorkbenchAutoStopCellProps extends SwitchProps {
  workbenchId: number;
  isAutostopEnabled: boolean;
}

const WorkbenchAutoStopCell: FC<WorkbenchAutoStopCellProps> = ({ workbenchId, isAutostopEnabled, ...props }) => {
  const projectId = +useParams().projectid!;
  const [autoStopWorkbench] = useAutoStopWorkbenchMutation({
    fixedCacheKey: `autostop-workbench-${workbenchId}`,
  });
  const [deleteAutoStopWorkbench] = useDeleteAutoStopWorkbenchMutation({
    fixedCacheKey: `autostop-workbench-${workbenchId}`,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      autoStopWorkbench({ workbenchId, projectId });
    } else {
      deleteAutoStopWorkbench({ workbenchId, projectId });
    }
  };

  return <Switch checked={isAutostopEnabled} onChange={handleChange} {...props} />;
};

export default WorkbenchAutoStopCell;
